import {
	type Action,
	SET_CARD_ID_WITH_ABOVE_ICC_OPEN,
	SET_RICH_ACTIVE_CARD,
} from '../../../../actions/cards/rich-card';
import type { RichCardState } from './types';

export type { Action };

export const initialState: RichCardState = {
	mainActiveCard: null,
	cardIdWithAboveIccOpen: null,
};

export const richCardReducer = (
	state: RichCardState | null | undefined,
	action: Action,
): RichCardState => {
	switch (action.type) {
		case SET_RICH_ACTIVE_CARD: {
			return {
				...(state || initialState),
				mainActiveCard: action.payload.cardId,
			};
		}

		case SET_CARD_ID_WITH_ABOVE_ICC_OPEN: {
			return {
				...(state || initialState),
				cardIdWithAboveIccOpen: action.payload.cardId,
			};
		}
		default: {
			const _exhaustiveCheck: never = action;
			return state || initialState;
		}
	}
};
